import React from "react";
import Table from "react-bootstrap/Table";
import "../scss/task.scss";
import DeleteIcon from "@mui/icons-material/Delete";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import idx from "idx";
import { laborObjFields } from "../../../constants/fields.constant";
import { updateItemAction, updateSubTaskAction } from "../../../slice/add-task";
import { useDispatch } from "react-redux";
import _ from "lodash";
import { useSelector } from "react-redux";
import { toUSD, numberFormat } from "../../../util/currency-formatter";
import { formatPlannedEffort } from "../../../util/common";
import { NumberInput } from "src/components/inputs/new-input";

const filter = createFilterOptions();

export default function Labor({
  labor = [],
  newLabor = [],
  total = {},
  subTaskArrayIndex,
  isDisabled,
  isVariation = false,
  handleAddLabor,
  ...props
}) {
  const projectSummary = useSelector((state) => state.projectSummary) || {};
  const resources = useSelector((state) => state.resources);
  const dispatch = useDispatch();
  const getLabor = (id) => {
    let allLabors = idx(resources, (_) => _.list) || [];
    return allLabors.find((labor) => labor.id === id) || {};
  };

  const filterLabor = (id) => {
    let laborsList = !_.isEmpty(idx(props, (_) => _.laborOptions))
      ? idx(props, (_) => _.laborOptions)
      : idx(projectSummary, (_) => _.labors) || [];
    let labor = laborsList.find((labor) => labor.id === id);
    if (!labor) {
      labor = getLabor(id);
      labor = _.cloneDeep(labor);
      labor["calloutCost"] = 0;
      labor["averageCost"] = labor.cost;
      labor["skillDescription"] = "";
    } else {
      if (!labor["averageCost"]) {
        let _temp = getLabor(id);
        labor = _.cloneDeep(labor);
        labor["averageCost"] = _temp.cost;
      }
    }
    return labor;
  };

  const laborChangeHandler = (e, index) => {
    const { subTaskArray } = props;
    let _temp = _.cloneDeep(subTaskArray);
    const labor = _temp[subTaskArrayIndex]["labor"][index];

    let quantity = parseFloat(labor.qty?.value) || 0;
    let costPerItem = parseFloat(labor.costPerItem?.value) || 0;
    let laborCost = parseFloat(labor.labor_cost) || 0;

    if (e.target.name === "qty") {
      quantity = parseFloat(e.target.value) || 0;
      labor.qty.value = quantity;
    }
    if (e.target.name === "costPerItem") {
      costPerItem = parseFloat(e.target.value) || 0;
      labor.costPerItem.value = costPerItem;
    }
    if (e.target.name === "labourCost") {
      laborCost = parseFloat(e.target.value) || 0;
      labor.labourCost.value = laborCost;
      labor.labor_cost = laborCost;
    }

    labor.total.value = quantity * costPerItem;
    const labor_Profit = costPerItem - laborCost;
    labor.labor_profit = labor_Profit * quantity;
    _temp.labor_profit = labor.labor_profit;

    const value = e.target.value;
    if (_temp[subTaskArrayIndex]["labor"][index][e.target.name]) {
      _temp[subTaskArrayIndex]["labor"][index][e.target.name].value = value;
    }
    _temp[subTaskArrayIndex]["labor"][index]["total"].value = quantity * costPerItem;
    _temp[subTaskArrayIndex]["isedited"] = true;
    dispatch(updateSubTaskAction(_temp));
  };

  const removeLabor = (index) => {
    const { subTaskArray } = props;
    let _temp = _.cloneDeep(subTaskArray);
    _temp[subTaskArrayIndex]["labor"].splice(index, 1);
    _temp[subTaskArrayIndex]["isedited"] = true;
    dispatch(updateSubTaskAction(_temp));
  };

  const addLabor = (value, tmpId) => {
    const selectedLabor = filterLabor(value.value);
    const labor = _.cloneDeep(laborObjFields);
    labor.name.value = selectedLabor.skill;
    labor.id.value = selectedLabor.id;
    labor.skillDescription.value = selectedLabor.skillDescription;
    labor.costPerItem.value = selectedLabor.cost || 0;
    labor.calloutCost.value = parseFloat(selectedLabor.calloutCost || 0);
    labor.labourCost.value = parseFloat(selectedLabor.averageCost || 0);
    labor.travelCost.value = 0;
    labor.labor_cost = selectedLabor.averageCost;
    labor.labor_profit = 0;
    labor.qty.value = 1;
    labor.is_personnel.value = selectedLabor.is_personnel !== undefined ? selectedLabor.is_personnel : true;
    labor.total.value = labor.qty.value * labor.costPerItem.value;

    const { subTaskArray } = props;
    let _temp = _.cloneDeep(subTaskArray);
    let labors = getNewLabors();

    _temp[subTaskArrayIndex]["labor"].push(labor);
    _temp[subTaskArrayIndex]["newLabor"] = labors.filter(
      (item) => item.id != tmpId
    );

    _temp[subTaskArrayIndex]["isedited"] = true;
    dispatch(updateSubTaskAction(_temp));
  };

  const getOptions = () => {
    return (idx(resources, (_) => _.active) || []).map((labor) => {
      return { key: labor.skill, value: labor.id };
    });
  };

  const getNewLabors = () => {
    const { subTaskArray } = props;
    let _temp = _.cloneDeep(subTaskArray);
    return _temp[subTaskArrayIndex]["newLabor"] || [];
  };
  const handleRemoveLabor = (tmpId) => {
    let labors = getNewLabors();
    labors = labors.filter((item) => item.id != tmpId);
    dispatch(updateItemAction({ labor: labors, index: subTaskArrayIndex }));
  };

  return (
    <>
      {[...labor, ...newLabor].length > 0 && (
        <div className="mb-2">
          <div className="border border-bottom-0 d-flex px-2 py-1 gap-3">
            <h2 className="py-1 tbl-heading">Resource List</h2>
          </div>
          <div className="material-list-block">
            <div className="table-responsive">
              <Table bordered className="table-create table-material tbl-fixed">
                <thead>
                  <tr>
                    <th className="">Resource(s)</th>
                    <th className="qty-width text-right">Planned Effort</th>
                    <th className="cost-width text-right">Cost($)</th>
                    <th className="cost-width text-right">Sale Amount($)</th>
                    <th className="qty-width text-right">Quantity</th>
                    <th className="text-right total-width">Total ($)</th>
                    <th className="text-right action-width">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {labor.map((_labor, laborIndex) => {
                    if (!_labor) return;
                    return (
                      <tr key={laborIndex}>
                        <td>
                          <p
                            title={idx(_labor, (_) => _.name.value)}
                            className="text-truncate m-0 table-text-sm"
                          >
                            {idx(_labor, (_) => _.name.value)}
                          </p>
                        </td>
                        <td className="text-right">
                          {formatPlannedEffort(_labor)}
                        </td>
                        <td>
                          <NumberInput
                            className="input-block-sm"
                            customInputClass="text-right"
                            disabled={isDisabled}
                            {..._labor.labourCost}
                            value={
                              idx(_labor, (_) => _.labourCost.value) ||
                              _labor.labor_cost ||
                              0
                            }
                            onChange={(e) => laborChangeHandler(e, laborIndex)}
                            onBlur={(e) => laborChangeHandler(e, laborIndex)}
                          />
                        </td>
                        <td>
                          <NumberInput
                            className="input-block-sm"
                            disabled={isDisabled}
                            {..._labor.costPerItem}
                            value={
                              idx(_labor, (_) => _.costPerItem.value) ||
                              idx(_labor, (_) => _.costPerItem) ||
                              0
                            }
                            onChange={(e) => laborChangeHandler(e, laborIndex)}
                            onBlur={(e) => laborChangeHandler(e, laborIndex)}
                            min={1}
                            customInputClass="text-right"
                          />
                        </td>
                        <td>
                          <NumberInput
                            className="input-block-sm"
                            disabled={isDisabled}
                            {..._labor.qty}
                            onChange={(e) => laborChangeHandler(e, laborIndex)}
                            onBlur={(e) => laborChangeHandler(e, laborIndex)}
                            allowNegative={isVariation}
                            {...(!isVariation && { min: 1 })}
                            customInputClass="text-right"
                          />
                        </td>
                        <td className="text-right">
                          {/* TODO: remove the roundOffValue function when calculations has been fixed of multiple decimals */}
                          {toUSD(idx(_labor, (_) => _.total.value))}
                        </td>
                        <td className="text-right">
                          {!isDisabled && (
                            <DeleteIcon
                              className="deleteicon"
                              onClick={() => removeLabor(laborIndex)}
                            />
                          )}
                        </td>
                      </tr>
                    );
                  })}

                  {newLabor.map((_labor) => (
                    <tr key={_labor.id}>
                      <td>
                        <div className="input-block-sm autocomplete-block autocomplete-block-ch">
                          <Autocomplete
                            onChange={(event, newValue) => {
                              if (typeof newValue === "string") {
                                newValue = { inputValue: newValue };
                              } else if (newValue && newValue.inputValue) {
                              } else if (newValue) {
                                addLabor(newValue, _labor.id);
                              }
                            }}
                            filterOptions={(options, params) =>
                              filter(options, params)
                            }
                            selectOnFocus
                            handleHomeEndKeys
                            options={getOptions()}
                            getOptionLabel={(option) =>
                              typeof option === "string" ? option : option.key
                            }
                            renderOption={(props, option) => (
                              <li {...props}>{option.key}</li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="standard"
                                label="Resource"
                              />
                            )}
                            disablePortal={true}
                            id="combo-box-demo"
                          />
                        </div>
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td className="text-right table-text-sm"></td>
                      <td className="text-right table-text-sm"></td>
                      <td className="text-right">
                        {!isDisabled && (
                          <DeleteIcon
                            className="deleteicon"
                            onClick={() => handleRemoveLabor(_labor.id)}
                          />
                        )}
                      </td>
                    </tr>
                  ))}

                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td className="text-right fs-6 py-1">
                      <span>{toUSD(idx(total, (_) => _.labor.sale))}</span>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
